


// import { REST_BASE, API_KEY } from './config';

// // ── Serializer: JS → Firestore REST ──────────────────────────────────────────

// function toValue(v) {
//   if (v === null || v === undefined) return { nullValue: null };
//   if (typeof v === 'boolean')        return { booleanValue: v };
//   if (typeof v === 'number') {
//     return Number.isInteger(v)
//       ? { integerValue: String(v) }
//       : { doubleValue: v };
//   }
//   if (typeof v === 'string')  return { stringValue: v };
//   if (Array.isArray(v))       return { arrayValue: { values: v.map(toValue) } };
//   if (typeof v === 'object')  return { mapValue: { fields: toFields(v) } };
//   return { stringValue: String(v) };
// }

// function toFields(obj) {
//   const fields = {};
//   for (const [k, v] of Object.entries(obj)) fields[k] = toValue(v);
//   return fields;
// }

// // ── Deserializer: Firestore REST → JS ────────────────────────────────────────

// function fromValue(v) {
//   if (!v) return null;
//   if ('stringValue'  in v) return v.stringValue;
//   if ('integerValue' in v) return Number(v.integerValue);
//   if ('doubleValue'  in v) return Number(v.doubleValue);
//   if ('booleanValue' in v) return v.booleanValue;
//   if ('nullValue'    in v) return null;
//   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
//   if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
//   return null;
// }

// function fromFields(fields) {
//   const obj = {};
//   for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
//   return obj;
// }

// function fromDoc(restDoc) {
//   return {
//     id: restDoc.name.split('/').pop(),
//     ...fromFields(restDoc.fields || {}),
//   };
// }

// // ── Core REST helpers ─────────────────────────────────────────────────────────

// async function request(method, path, body) {
//   const sep = path.includes('?') ? '&' : '?';
//   const url  = `${REST_BASE}${path}${sep}key=${API_KEY}`;
//   const res  = await fetch(url, {
//     method,
//     headers: body ? { 'Content-Type': 'application/json' } : {},
//     body:    body ? JSON.stringify(body) : undefined,
//   });

//   if (res.status === 404 && method === 'GET') return null;

//   if (!res.ok) {
//     const err = await res.json().catch(() => ({}));
//     throw new Error(
//       err?.error?.message || `Firestore REST ${res.status} on ${method} ${path}`
//     );
//   }

//   if (res.status === 204 || res.headers.get('content-length') === '0') return null;
//   return res.json();
// }

// // ── REST CRUD ─────────────────────────────────────────────────────────────────

// async function restGetAll(col, orderByField = null) {
//   const docs = [];
//   let pageToken = null;
//   do {
//     let path = `/${col}`;
//     const params = [];
//     if (orderByField) params.push(`orderBy=${encodeURIComponent(orderByField)}`);
//     if (pageToken)    params.push(`pageToken=${encodeURIComponent(pageToken)}`);
//     if (params.length) path += '?' + params.join('&');

//     const json = await request('GET', path);
//     if (!json) return [];
//     if (Array.isArray(json.documents)) docs.push(...json.documents.map(fromDoc));
//     pageToken = json.nextPageToken || null;
//   } while (pageToken);
//   return docs;
// }

// async function restAdd(col, data) {
//   const json = await request('POST', `/${col}`, { fields: toFields(data) });
//   return json.name.split('/').pop();
// }

// async function restUpdate(col, id, data) {
//   const fieldPaths = Object.keys(data)
//     .map(k => `updateMask.fieldPaths=${encodeURIComponent(k)}`)
//     .join('&');
//   await request('PATCH', `/${col}/${id}?${fieldPaths}`, { fields: toFields(data) });
// }

// async function restSet(col, id, data) {
//   await request('PATCH', `/${col}/${id}`, { fields: toFields(data) });
// }

// async function restDelete(col, id) {
//   await request('DELETE', `/${col}/${id}`);
// }

// // ── Public service objects ────────────────────────────────────────────────────

// export const projectsService = {
//   getAll: ()         => restGetAll('projects', 'order'),
//   add:    (data)     => restAdd('projects', data),
//   update: (id, data) => restUpdate('projects', id, data),
//   remove: (id)       => restDelete('projects', id),
// };

// export const skillGroupsService = {
//   getAll: ()         => restGetAll('skillGroups'),
//   add:    (data)     => restAdd('skillGroups', data),
//   update: (id, data) => restUpdate('skillGroups', id, data),
//   remove: (id)       => restDelete('skillGroups', id),
// };

// export const experiencesService = {
//   getAll: ()         => restGetAll('experiences', 'order'),
//   add:    (data)     => restAdd('experiences', data),
//   update: (id, data) => restUpdate('experiences', id, data),
//   remove: (id)       => restDelete('experiences', id),
// };

// export const certificatesService = {
//   getAll: ()         => restGetAll('certificates', 'order'),
//   add:    (data)     => restAdd('certificates', data),
//   update: (id, data) => restUpdate('certificates', id, data),
//   remove: (id)       => restDelete('certificates', id),
// };

// // ── Theme service — single document at theme/colors ───────────────────────────

// export const themeService = {
//   get: async () => {
//     const json = await request('GET', '/theme/colors');
//     if (!json) return null;
//     const fields = json.fields || {};
//     return Object.fromEntries(
//       Object.entries(fields).map(([k, v]) => [k, v.stringValue || ''])
//     );
//   },
//   save: async (colorMap) => {
//     const fields = {};
//     for (const [k, v] of Object.entries(colorMap)) {
//       fields[k] = { stringValue: v };
//     }
//     await request('PATCH', '/theme/colors', { fields });
//   },
//   reset: async () => {
//     await request('DELETE', '/theme/colors');
//   },
// };

// // ── Projects Outro Quote service — single document at projectsMeta/quote ───────
// // Document shape: { lines: string[], attribution: string }
// //
// // lines[]      — each element is one animated line shown in sequence
// // attribution  — the small credit line shown after all lines (e.g. "— Dieter Rams")

// const DEFAULT_QUOTE = {
//   lines:       ['about what you add,', 'but what you leave out.'],
//   attribution: '',
// };

// export const projectsQuoteService = {
//   // Returns { lines: string[], attribution: string } or DEFAULT_QUOTE
//   get: async () => {
//     const json = await request('GET', '/projectsMeta/quote');
//     if (!json) return { ...DEFAULT_QUOTE };
//     const fields = json.fields || {};

//     // lines is stored as an arrayValue of stringValues
//     const rawLines = fields.lines?.arrayValue?.values || [];
//     const lines = rawLines
//       .map(v => v.stringValue || '')
//       .filter(Boolean);

//     const attribution = fields.attribution?.stringValue || DEFAULT_QUOTE.attribution;

//     return {
//       lines:       lines.length ? lines : DEFAULT_QUOTE.lines,
//       attribution,
//     };
//   },

//   // Saves { lines: string[], attribution: string } to Firestore
//   save: async ({ lines, attribution }) => {
//     const fields = {
//       lines: {
//         arrayValue: {
//           values: lines.filter(Boolean).map(l => ({ stringValue: l })),
//         },
//       },
//       attribution: { stringValue: attribution },
//     };
//     await request('PATCH', '/projectsMeta/quote', { fields });
//   },

//   // Resets to defaults by deleting the document
//   reset: async () => {
//     await request('DELETE', '/projectsMeta/quote');
//   },
// };

// // Export helpers for seed.js
// export { restSet, restGetAll };


import { REST_BASE, API_KEY } from './config';

// ── Serializer: JS → Firestore REST ──────────────────────────────────────────

function toValue(v) {
  if (v === null || v === undefined) return { nullValue: null };
  if (typeof v === 'boolean')        return { booleanValue: v };
  if (typeof v === 'number') {
    return Number.isInteger(v)
      ? { integerValue: String(v) }
      : { doubleValue: v };
  }
  if (typeof v === 'string')  return { stringValue: v };
  if (Array.isArray(v))       return { arrayValue: { values: v.map(toValue) } };
  if (typeof v === 'object')  return { mapValue: { fields: toFields(v) } };
  return { stringValue: String(v) };
}

function toFields(obj) {
  const fields = {};
  for (const [k, v] of Object.entries(obj)) fields[k] = toValue(v);
  return fields;
}

// ── Deserializer: Firestore REST → JS ────────────────────────────────────────

function fromValue(v) {
  if (!v) return null;
  if ('stringValue'  in v) return v.stringValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue'  in v) return Number(v.doubleValue);
  if ('booleanValue' in v) return v.booleanValue;
  if ('nullValue'    in v) return null;
  if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
  if ('mapValue'     in v) return fromFields(v.mapValue.fields || {});
  return null;
}

function fromFields(fields) {
  const obj = {};
  for (const [k, v] of Object.entries(fields)) obj[k] = fromValue(v);
  return obj;
}

function fromDoc(restDoc) {
  return {
    id: restDoc.name.split('/').pop(),
    ...fromFields(restDoc.fields || {}),
  };
}

// ── Core REST helpers ─────────────────────────────────────────────────────────

async function request(method, path, body) {
  const sep = path.includes('?') ? '&' : '?';
  const url  = `${REST_BASE}${path}${sep}key=${API_KEY}`;
  const res  = await fetch(url, {
    method,
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body:    body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 404 && method === 'GET') return null;

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err?.error?.message || `Firestore REST ${res.status} on ${method} ${path}`
    );
  }

  if (res.status === 204 || res.headers.get('content-length') === '0') return null;
  return res.json();
}

// ── REST CRUD ─────────────────────────────────────────────────────────────────

async function restGetAll(col, orderByField = null) {
  const docs = [];
  let pageToken = null;
  do {
    let path = `/${col}`;
    const params = [];
    if (orderByField) params.push(`orderBy=${encodeURIComponent(orderByField)}`);
    if (pageToken)    params.push(`pageToken=${encodeURIComponent(pageToken)}`);
    if (params.length) path += '?' + params.join('&');

    const json = await request('GET', path);
    if (!json) return [];
    if (Array.isArray(json.documents)) docs.push(...json.documents.map(fromDoc));
    pageToken = json.nextPageToken || null;
  } while (pageToken);
  return docs;
}

async function restAdd(col, data) {
  const json = await request('POST', `/${col}`, { fields: toFields(data) });
  return json.name.split('/').pop();
}

async function restUpdate(col, id, data) {
  const fieldPaths = Object.keys(data)
    .map(k => `updateMask.fieldPaths=${encodeURIComponent(k)}`)
    .join('&');
  await request('PATCH', `/${col}/${id}?${fieldPaths}`, { fields: toFields(data) });
}

async function restSet(col, id, data) {
  await request('PATCH', `/${col}/${id}`, { fields: toFields(data) });
}

async function restDelete(col, id) {
  await request('DELETE', `/${col}/${id}`);
}

// ── Public service objects ────────────────────────────────────────────────────

export const projectsService = {
  getAll: ()         => restGetAll('projects', 'order'),
  add:    (data)     => restAdd('projects', data),
  update: (id, data) => restUpdate('projects', id, data),
  remove: (id)       => restDelete('projects', id),
};

export const skillGroupsService = {
  getAll: ()         => restGetAll('skillGroups'),
  add:    (data)     => restAdd('skillGroups', data),
  update: (id, data) => restUpdate('skillGroups', id, data),
  remove: (id)       => restDelete('skillGroups', id),
};

export const experiencesService = {
  getAll: ()         => restGetAll('experiences', 'order'),
  add:    (data)     => restAdd('experiences', data),
  update: (id, data) => restUpdate('experiences', id, data),
  remove: (id)       => restDelete('experiences', id),
};

export const certificatesService = {
  getAll: ()         => restGetAll('certificates', 'order'),
  add:    (data)     => restAdd('certificates', data),
  update: (id, data) => restUpdate('certificates', id, data),
  remove: (id)       => restDelete('certificates', id),
};

// ── Blogs service ─────────────────────────────────────────────────────────────
// Document shape:
//   { tag, color, title, excerpt, date, readTime, cover, order, published }
//
// tag        — uppercase category label, e.g. "GSAP"
// color      — accent hex used for tag badge & border
// title      — post title
// excerpt    — short teaser paragraph
// date       — display string, e.g. "MAY 2025"
// readTime   — display string, e.g. "6 MIN"
// cover      — full image URL
// order      — integer for sort order
// published  — boolean; false = draft, true = live on portfolio

export const blogsService = {
  getAll: ()         => restGetAll('blogs', 'order'),
  add:    (data)     => restAdd('blogs', data),
  update: (id, data) => restUpdate('blogs', id, data),
  remove: (id)       => restDelete('blogs', id),
};

// ── Theme service — single document at theme/colors ───────────────────────────

export const themeService = {
  get: async () => {
    const json = await request('GET', '/theme/colors');
    if (!json) return null;
    const fields = json.fields || {};
    return Object.fromEntries(
      Object.entries(fields).map(([k, v]) => [k, v.stringValue || ''])
    );
  },
  save: async (colorMap) => {
    const fields = {};
    for (const [k, v] of Object.entries(colorMap)) {
      fields[k] = { stringValue: v };
    }
    await request('PATCH', '/theme/colors', { fields });
  },
  reset: async () => {
    await request('DELETE', '/theme/colors');
  },
};


// ── Skills Meta service — single document at skillsMeta/main ──────────────────
// Document shape: { floatingImage: string }

export const skillsMetaService = {
  get: async () => {
    const json = await request('GET', '/skillsMeta/main');
    if (!json) return null;
    return fromDoc(json);
  },
  save: async (data) => {
    await request('PATCH', '/skillsMeta/main', { fields: toFields(data) });
  },
};

// ── Projects Outro Quote service — single document at projectsMeta/quote ───────
// Document shape: { lines: string[], attribution: string }
//
// lines[]      — each element is one animated line shown in sequence
// attribution  — the small credit line shown after all lines (e.g. "— Dieter Rams")

const DEFAULT_QUOTE = {
  lines:       ['about what you add,', 'but what you leave out.'],
  attribution: '',
};

export const projectsQuoteService = {
  // Returns { lines: string[], attribution: string } or DEFAULT_QUOTE
  get: async () => {
    const json = await request('GET', '/projectsMeta/quote');
    if (!json) return { ...DEFAULT_QUOTE };
    const fields = json.fields || {};

    // lines is stored as an arrayValue of stringValues
    const rawLines = fields.lines?.arrayValue?.values || [];
    const lines = rawLines
      .map(v => v.stringValue || '')
      .filter(Boolean);

    const attribution = fields.attribution?.stringValue || DEFAULT_QUOTE.attribution;

    return {
      lines:       lines.length ? lines : DEFAULT_QUOTE.lines,
      attribution,
    };
  },

  // Saves { lines: string[], attribution: string } to Firestore
  save: async ({ lines, attribution }) => {
    const fields = {
      lines: {
        arrayValue: {
          values: lines.filter(Boolean).map(l => ({ stringValue: l })),
        },
      },
      attribution: { stringValue: attribution },
    };
    await request('PATCH', '/projectsMeta/quote', { fields });
  },

  // Resets to defaults by deleting the document
  reset: async () => {
    await request('DELETE', '/projectsMeta/quote');
  },
};

// Export helpers for seed.js
export { restSet, restGetAll };